// GroupBadge — part of the product option modal (ProductOptionView).

export default function GroupBadge({ required, limit, count, pick, t }) {
  const state = required ? t('requiredLabel', 'Required') : t('optionalLabel', 'Optional');
  let detail = null;

  if (limit > 0) {
    detail = `${count}/${limit}`;
  } else if (pick > 0) {
    detail = `${t('pick', 'Pick')} ${pick}`;
  }

  return (
    <span className={`po-group-badge ${required ? 'is-required' : ''}`}>
      {state}
      {detail ? <span className="po-group-badge-detail"> · {detail}</span> : null}
    </span>
  );
}
